import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import DashboardHome from "./views/DashboardHome";
import UserGrowth from "./views/UserGrowth";
import ViralMetrics from "./views/ViralMetrics";
import Revenue from "./views/Revenue";
import SMSMonitoring from "./views/SMSMonitoring";
import SystemHealth from "./views/SystemHealth";

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardHome />} />
        <Route path="/users" element={<UserGrowth />} />
        <Route path="/viral" element={<ViralMetrics />} />
        <Route path="/revenue" element={<Revenue />} />
        <Route path="/sms" element={<SMSMonitoring />} />
        <Route path="/health" element={<SystemHealth />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
